/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free: NonNullable<unknown>, pro: NonNullable<unknown> }} Products_Leveling_Faq_Rules_AInputs */



/**
* | output |
* | --- |
* | "Earning rules and multipliers count together: {free} on Free, {pro} on Pro and no limit on Titan. Free keeps the two default earning rules and adds multiplie..." |
*
* @param {Products_Leveling_Faq_Rules_AInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_rules_a = /** @type {((inputs: Products_Leveling_Faq_Rules_AInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Rules_AInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Правила начисления и множители считаются вместе: ${i?.free} на Free, ${i?.pro} на Pro и без ограничений на Titan. На Free остаются два правила начисления по умолчанию и к ним добавляются множители, а на Pro и Titan можно писать свои правила.`)
	return /** @type {LocalizedString} */ (`Earning rules and multipliers count together: ${i?.free} on Free, ${i?.pro} on Pro and no limit on Titan. Free keeps the two default earning rules and adds multipliers; Pro and Titan let you write your own.`)
});